if ( typeof ProductPage !== 'function' ) {

	class ProductPage extends HTMLElement {

		constructor(){

			super();

			this.productGallery = this.querySelector('[data-js-product-gallery]');
			this.productSlider = this.querySelector('css-slider');

			// Gallery thumbnails

			if ( this.productSlider ) {

				const productGaleryThumbnails = this.querySelector('.product-gallery__thumbnails-holder');

				if ( this.querySelector('.product-gallery__thumbnails .thumbnail') ) {

					this.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach((elm, i)=>{
						if ( i == 0 )  {
							elm.classList.add('active');
						}
						elm.addEventListener('click',e=>{
							if ( this.productSlider.sliderEnabled ) {
								this.productSlider.changeSlide(e.currentTarget.dataset.index);
							} else {
								window.scrollTo({
									top: this.productGallery.querySelector(`.product-gallery-item[data-index="${e.currentTarget.dataset.index}"]`).offsetTop + this.offsetTop,
									behavior: 'smooth'
								});
								this.thumbnailNavigationHelper(e.currentTarget.dataset.index);
							}
							productGaleryThumbnails.scrollTo({
								left: elm.offsetLeft - 50,
								behaviour: 'smooth'
							})
						});
					})

					this.productSlider.addEventListener('change', e=>{
						this.thumbnailNavigationHelper(e.target.index);
					});

				}

				this.productSlider.addEventListener('change', e=>{
					if ( this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`).dataset.productMediaType == 'model' ) {
						if ( this.xrButton ) {
							this.xrButton.setAttribute('data-shopify-model3d-id', this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`).dataset.mediaId);
						}
						setTimeout(()=>{
							this.productSlider.querySelector('.css-slider-holder').classList.add('css-slider--disable-dragging');
						}, 150);
					}
				});

				// Parallax

				if ( this.productGallery.dataset.jsDisableParallax == 'false' ) {
					this.productSlider.addEventListener('ready', (e)=>{
						
						if ( this.firstProductGalleryIndex ) {
							this.productSlider.changeSlide(this.firstProductGalleryIndex, "auto");
						}

						const productSlides = this.productSlider.querySelectorAll('.product-gallery-item');
						const productFigures = this.querySelectorAll('.apply-gallery-animation');
						this.productSlider.addEventListener('scroll', ()=>{
							const scrollX = -this.productSlider.element.scrollLeft;
							productSlides.forEach((slide,i)=>{
								const media = productFigures[i];
								if ( media ) {
									media.style.transform = `translateX(${( slide.offsetLeft + scrollX ) * -1/3}px)`;
								}
							});
						});

					});
				}

			}

			// show cart drawer when element is added to cart

			if ( ! document.body.classList.contains('template-cart') && ( KROWN.settings.cart_action == 'overlay' || KROWN.settings.cart_action == 'popup' ) ) {
				
				let addToCartEnter = false;
				if ( this.querySelector('[data-js-product-add-to-cart]') ) {
					this.querySelector('[data-js-product-add-to-cart]').addEventListener('keyup', e=>{
						if ( e.keyCode == window.KEYCODES.RETURN ) {
							addToCartEnter = true;
							window.lastFocusedElm = this.querySelector('[data-js-product-add-to-cart]');
						}
					})
				}	

				if ( this.querySelector('[data-js-product-form]') ) {
					this.querySelector('[data-js-product-form]').addEventListener('add-to-cart', ()=>{
						document.getElementById('site-cart-sidebar').show();
						if ( document.getElementById('cart-recommendations') ) {
							document.getElementById('cart-recommendations').generateRecommendations();
						}
						if ( addToCartEnter ) {
							setTimeout(()=>{
								document.querySelector('#site-cart-sidebar [data-js-close]').focus();
								addToCartEnter = false;
							}, 200);
						}
					});
				}

			}

			// Check for models

			const models = this.querySelectorAll('product-model');
			if ( models.length > 0 ) {
				window.ProductModel.loadShopifyXR();
				this.xrButton = this.querySelector('.product-gallery__view-in-space');
			}

			// hide buy now button if stock disabled

			const addToCartButton = this.querySelector('[data-js-product-add-to-cart]');
			if ( addToCartButton ) {
				if ( addToCartButton.classList.contains('disabled') ) {
					this.querySelector('product-form').classList.add('disable-buy-button');
				} else {
					this.querySelector('product-form').classList.remove('disable-buy-button');
				}
				const buyObserver = new MutationObserver(()=>{
					if ( addToCartButton.classList.contains('disabled') ) {
						this.querySelector('product-form').classList.add('disable-buy-button');
					} else {
						this.querySelector('product-form').classList.remove('disable-buy-button');
					}
				});
				buyObserver.observe(addToCartButton,{ attributes: true, childList: false, subtree: false });
			}



			// Product variant event listener for theme specific logic

			this.productVariants = this.querySelector('product-variants[data-main-product-variants]');
			if ( this.productVariants ) {
				this.productVariants.addEventListener('VARIANT_CHANGE', this.onVariantChangeHandler.bind(this));
				// Initial filter: run directly (does not depend on currentVariant being
				// populated yet) so the gallery is correct on first paint, not only after
				// the customer changes an option.
				this.filterGalleryByVariant();
				this.thumbnailNavigationHelper(0);
			}

		}

		thumbnailNavigationHelper(index=0){
			this.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach((elm, i)=>{
				if ( i == index )
					elm.classList.add('active');
				else 
					elm.classList.remove('active');
			});
		}

		onVariantChangeHandler(e){

			let variant = e.target.currentVariant;
			if ( variant ) {

				// Filter gallery images by selected option values (matched via alt text)
				this.filterGalleryByVariant();

				// Also update thumbnail active state
				this.thumbnailNavigationHelper(0);

			}
		}

		filterGalleryByVariant(){

			// Helper: whole-word matching. An option value matches an alt only when
			// every word of the value appears as a standalone word in the alt, so
			// "white gold" needs both words and letter "d" can no longer match "gold".
			const tokenize = (str) => str.toLowerCase().split(/[^a-z0-9]+/).filter(Boolean);
			const valueMatches = (altTokens, val) => {
				const parts = tokenize(val);
				return parts.length > 0 && parts.every(part => altTokens.includes(part));
			};

			// Build one group per option (Colour, Size, Metal, Letter...), each holding the
			// value currently selected plus every value that option can take.
			const optionGroups = [];

			this.querySelectorAll('product-variants select[data-js-product-variant-container]').forEach(sel => {
				const values = Array.from(sel.options)
					.filter(o => ! o.disabled)
					.map(o => (o.value || '').trim().toLowerCase())
					.filter(Boolean);
				const selected = (sel.value || '').trim().toLowerCase();
				if ( selected && values.length ) optionGroups.push({ selected, values });
			});

			const radioGroups = {};
			this.querySelectorAll('product-variants input[type="radio"]').forEach(inp => {
				const val = (inp.value || '').trim().toLowerCase();
				if ( ! val ) return;
				const key = inp.name || 'radio';
				if ( ! radioGroups[key] ) radioGroups[key] = { selected: '', values: [] };
				radioGroups[key].values.push(val);
				if ( inp.checked ) radioGroups[key].selected = val;
			});
			Object.keys(radioGroups).forEach(key => {
				if ( radioGroups[key].selected ) optionGroups.push(radioGroups[key]);
			});

			if ( optionGroups.length === 0 ) return;

			const allSlides = this.productGallery.querySelectorAll('.product-gallery-item, .product-gallery-item--hidden');
			const allThumbs = this.querySelectorAll('.product-gallery__thumbnails .thumbnail, .product-gallery__thumbnails .thumbnail--hidden');

			// Which options are actually written into this product's alt text? Ring sizes and
			// chain lengths usually are not, and filtering on an option no alt mentions hides
			// every image. So only options present in at least one alt are used to filter.
			const altTokenSets = Array.from(allSlides).map(item => tokenize(item.dataset.mediaAlt || ''));
			const activeGroups = optionGroups.filter(group =>
				group.values.some(val => altTokenSets.some(tokens => valueMatches(tokens, val)))
			);

			if ( activeGroups.length === 0 ) return;

			// Helper: should this media be visible?
			//  - alts referencing no filterable option value (lifestyle shots) always show
			//  - otherwise the alt must match the selected value of every filterable option
			const shouldShow = (alt) => {
				if ( ! alt ) return true;
				const altTokens = tokenize(alt);
				const referencesOption = activeGroups.some(group =>
					group.values.some(val => valueMatches(altTokens, val))
				);
				if ( ! referencesOption ) return true;
				return activeGroups.every(group => valueMatches(altTokens, group.selected));
			};

			// Toggle gallery slides: hide by removing class so slider ignores them
			let visibleIndex = 0;
			allSlides.forEach(item => {
				if ( shouldShow(item.dataset.mediaAlt) ) {
					item.classList.add('product-gallery-item');
					item.classList.remove('product-gallery-item--hidden');
					item.classList.add('css-slide');
					item.style.display = '';
					item.dataset.index = visibleIndex;
					visibleIndex++;
				} else {
					item.classList.remove('product-gallery-item');
					item.classList.add('product-gallery-item--hidden');
					item.classList.remove('css-slide');
					item.style.display = 'none';
				}
			});

			// Toggle thumbnails
			let thumbIndex = 0;
			allThumbs.forEach(thumb => {
				if ( shouldShow(thumb.dataset.mediaAlt) ) {
					thumb.classList.add('thumbnail');
					thumb.classList.remove('thumbnail--hidden');
					thumb.style.display = '';
					thumb.dataset.index = thumbIndex;
					thumbIndex++;
				} else {
					thumb.classList.remove('thumbnail');
					thumb.classList.add('thumbnail--hidden');
					thumb.style.display = 'none';
				}
			});

			// Refresh slider: afterAppend re-queries items, resetSlider recalculates
			// (skipped while the slider element is not upgraded yet: component-slider.js
			// loads after this file, and the slider reads its slides itself when it starts)
			if ( this.productSlider && typeof this.productSlider.afterAppend === 'function' ) {
				this.productSlider.afterAppend();
				this.productSlider.resetSlider();
			}

		}
	}

  if ( typeof customElements.get('product-page') == 'undefined' ) {
		customElements.define('product-page', ProductPage);
	}

}